export const createReducer =
    (handlers, initialState = null) => 
    (state = initialState, action) =>
        handlers[action.type]?.(state, action) ?? state;

export default createReducer;
